/* eslint-disable prettier/prettier */
/* eslint-disable */

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import RotatingCard from "./components/RotatingCards";
import RotatingCardFront from "./components/RotatingCards/RotatingCardFront";
import RotatingCardBack from "./components/RotatingCards/RotatingCardBack";

// Images
import bgImage from "assets/images/leie/t-event-leie-bg.jpg";
import logo from "assets/images/logos/T-event/fulllogo_transparent.png";
import utleieImage from "assets/images/leie/T-event-utleie-mid-section.jpg";
import routes from "routes";
import Footer from "footer.routes";

//animations
import useScrollFadeIn from "hooks/useScrollFadeIn";
import useFadeInOnLoad from "hooks/useFadeInOnLoad"; 

//Card images
import lydutstyrFront from "assets/images/leie/cards/fronts/t-event-sound-gear-card-front.jpg";
import lydutstyrBack from "assets/images/leie/cards/backs/t-event-sound-gear-card-back.jpg";

import lysutstyrFront from "assets/images/leie/cards/fronts/t-event-lighting-gear-card-front.jpg";
import lysutstyrBack from "assets/images/leie/cards/backs/t-event-lighting-gear-card-back.jpg";

import spesialeffekterFront from "assets/images/leie/cards/fronts/t-event-effects-gear-card-front.jpg";
import spesialeffekterBack from "assets/images/leie/cards/backs/t-event-effects-gear-card-back.jpg";

import djmusikereFront from "assets/images/leie/cards/fronts/t-event-dj-card-front-cropped.jpg";
import djmusikereBack from "assets/images/leie/cards/backs/t-event-dj-card-back-cropped-2.jpg";

import eventutstyrFront from "assets/images/leie/cards/fronts/t-event-other-gear-card-front.jpg";
import eventutstyrBack from "assets/images/leie/cards/backs/t-event-other-gear-card-back.jpg";

function Utleie() {

    const headingRef = useFadeInOnLoad(0.6);
    const subheadingRef = useFadeInOnLoad(0.9);
    const logoRef = useFadeInOnLoad(0.6);
    const infoRef = useScrollFadeIn();

  return (
    <>
      <DefaultNavbar routes={routes} />

      {/* HERO SECTION */}
      <MKBox
          minHeight="100vh"
          width="100%"
          position="relative"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",  // Sørger for at bildet dekker hele området
            backgroundPosition: { xs: "center center", sm: "center center", md: "center center" },  // Bildet er alltid sentrert
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            display: "grid",
            placeItems: "center",
            overflow: "hidden",
          }}
        >
        {/* Mørkt overlay over bakgrunnsbildet */}
        <MKBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)", // Mørkere bakgrunn
            zIndex: 1,
          }}
        />

          <Container sx={{ position: "relative", zIndex: 3, textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" justifyContent="center" xs={12} lg={7} mx="auto">
            
            {/* Logo fades inn ved sidens load */}
            <MKBox ref={logoRef} component="img" src={logo} alt="T-Events Logo" width={{ xs: "200px", sm: "250px", md: "350px" }} mb={2} sx={{
              filter: "brightness(0) invert(1)",
              display: "block",
              mx: "auto",
              marginTop: { xs: "40px", md: "80px" },
            }} />

            {/* Overskrift fades inn ved sidens load */}
            <MKTypography ref={headingRef} variant="h1" color="white" textAlign="center" px={{ xs: 4, lg: 10 }} mt={1} sx={{
              fontSize: { xs: "28px", sm: "36px", md: "42px" },
              fontWeight: 200,
            }}>
              UTLEIE AV LYD, LYS OG EVENTUTSTYR
            </MKTypography>

            {/* Undertekst fades inn ved sidens load */}
            <MKTypography ref={subheadingRef} variant="h5" color="white" textAlign="center" px={{ xs: 4, lg: 10 }} mt={1} sx={{ 
              fontSize: '18px',                 
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
            }}>
              Lag et uforglemmelig event med T-Event.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>

      {/* UTLEIE SEKSJON */}
      <Card ref={infoRef} sx={{ p: 2, mx: { xs: 2, lg: 3 }, mt: -6, mb: 4, position: "relative", zIndex: 4 }}>

        <MKBox pt={6} pb={6}>
          <Container>
            <Grid container spacing={4} justifyContent="center">
              {/* Lydutstyr Card */}
              <Grid item xs={12} md={4}>
                <RotatingCard flipIcon="music_note">
                  <RotatingCardFront
                    image={lydutstyrFront}
                    icon="music_note"
                    title="Lydutstyr"
                    description="Klar lyd, uansett event."
                  />
                  <RotatingCardBack
                    image={lydutstyrBack}
                    title=""
                    description="Lydutstyr fra d&b, L-acoustics og mer. Perfekt lyd for ditt arrangement!"
                  >
                    <img
                      src={lydutstyrBack}
                      alt="Lydutstyr"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </RotatingCardBack>
                </RotatingCard>
              </Grid>

              {/* Lysutstyr Card */}
              <Grid item xs={12} md={4}>
                <RotatingCard flipIcon="lightbulb">
                  <RotatingCardFront
                    image={lysutstyrFront}
                    icon="lightbulb"
                    title="Lysutstyr"
                    description="Skap magiske lyssettinger!"
                  />
                  <RotatingCardBack
                    image={lysutstyrBack}
                    title=""
                    description="Lysutstyr fra Martin, Chauvet og andre kjente merker. Fra enkle lyssettinger til storslåtte lysshow!"
                  >
                    <img
                      src={lysutstyrBack}
                      alt="Lysutstyr"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </RotatingCardBack>
                </RotatingCard>
              </Grid>

              {/* Spesialeffekter Card */}
              <Grid item xs={12} md={4}>
                <RotatingCard flipIcon="flash_on">
                  <RotatingCardFront
                    image={spesialeffekterFront}
                    icon="flash_on"
                    title="Effekter"
                    description="Forvandle eventet med spesialeffekter!"
                  />
                  <RotatingCardBack
                    image={spesialeffekterBack}
                    title=""
                    description="Spesialeffekter som gjør ditt event minneverdig. Røykmaskiner, konfetti, og mer!"
                  >
                    <img
                      src={spesialeffekterBack}
                      alt="Spesialeffekter"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </RotatingCardBack>
                </RotatingCard>
              </Grid>

              {/* DJs Card */}
              <Grid item xs={12} md={4}>
                <RotatingCard flipIcon="headset_mic">
                  <RotatingCardFront
                    image={djmusikereFront}
                    icon="headset_mic"
                    title="DJs"
                    description="Skap stemningen med profesjonelle DJ-er."
                  />
                  <RotatingCardBack
                    image={djmusikereBack}
                    title=""
                    description="Våre DJ-er og musikere skaper en unik stemning på ditt event."
                  >
                    <img
                      src={djmusikereBack}
                      alt="DJ & Musikere"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </RotatingCardBack>
                </RotatingCard>
              </Grid>

              {/* Eventutstyr Card */}
              <Grid item xs={12} md={4}>
                <RotatingCard flipIcon="chair">
                  <RotatingCardFront
                    image={eventutstyrFront}
                    icon="chair"
                    title="Annet utstyr"
                    description="Alt du trenger for et vellykket event."
                  />
                  <RotatingCardBack
                    image={eventutstyrBack}
                    title=""
                    description="Eventutstyr tilpasset ditt arrangement. Vi har alt du trenger!"
                  >
                    <img
                      src={eventutstyrBack}
                      alt="Eventutstyr"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </RotatingCardBack>
                </RotatingCard>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>

      {/* MIDSECTION IMAGE */}
      <MKBox className="midsection-image" minHeight="60vh" width="100%" position="relative" sx={{
        backgroundImage: `url(${utleieImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
        overflow: "hidden",
        zIndex: 2,
        marginTop: "-80px",
      }}>
        <MKBox sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.4)",
          zIndex: 1,
        }} />
      </MKBox>

      {/* "TA KONTAKT FOR MER INFORMASJON" SECTION */}
      <MKBox pt={6} pb={6} sx={{ backgroundColor: "#f4f4f4", textAlign: "center" }}>
        <Container>
          <MKTypography variant="h4" color="primary" mb={3}>
            Ta kontakt for mer informasjon og prisoverslag
          </MKTypography>
          <MKTypography color="textSecondary" fontSize="18px" mb={2}>
            Vi er her for å hjelpe deg! Send oss melding eller ring oss i dag for å få mer informasjon om vårt utleieutstyr og tilpasset prisoverslag for ditt event.
          </MKTypography>
          <MKBox mt={3}>
            <MKTypography
              component="a"
              href="/kontakt-oss"
              variant="body1"
              color="primary"
              sx={{ textDecoration: "underline" }}
            >
              Besøk vår kontaktside her
            </MKTypography>
          </MKBox>
        </Container>
      </MKBox>

      {/* FOOTER */}
      <MKBox pt={6} px={1} mt={6}>
        <Footer />
      </MKBox>
    </>
  );
}

export default Utleie;
